import { Component } from '@angular/core';
import {
  RentalAgreementStatus,
  RentalAgreementStatusesDisplayNames
} from '@app/features/operations/rental-agreements/rental-agreements.model';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ChipModule } from 'primeng/chip';

@Component({
  selector: 'app-ra-status-renderer',
  standalone: true,
  imports: [ChipModule],
  templateUrl: './ra-status-renderer.component.html',
  host: { class: 'd-block text-center' }
})
export class RaStatusRendererComponent implements ICellRendererAngularComp {
  value: RentalAgreementStatus = 0;
  displayName = '';

  agInit(params: ICellRendererParams): void {
    this.value = params.value;
    this.displayName = RentalAgreementStatusesDisplayNames[params.value];
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    this.displayName = RentalAgreementStatusesDisplayNames[params.value];
    return true;
  }
}
